// import { enviroments } from '@infrastructure/enviroments';
import { enviroments } from '@infrastructure/enviroments';
import { Modal } from '@models';
import { base } from '@service/base';
import { CountResponse, TakeSkipFilter } from '@typings';

const BANNER_MS_BASE_URL = enviroments.BASE_URL;

export async function getAllModal({
  take,
  skip,
  filter,
}: TakeSkipFilter): Promise<CountResponse<Modal.IModal>> {
  let where = {};
  if (filter) {
    Object.keys(filter).forEach(key => {
      if (filter[key]) {
        where = {
          ...where,
          [key]: filter[key],
        };
      }
    });
  }

  const { data } = await base({
    baseURL: BANNER_MS_BASE_URL,
    url: `/modal`,
    method: 'GET',
    params: {
      ...where,
      skip,
      take,
    },
  });

  if (!data) {
    throw Error(data.message);
  }

  return data;
}
